import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Plane, Check } from 'lucide-react';

const cabinClasses = [
  { value: 'economy', label: 'Economy' },
  { value: 'premium_economy', label: 'Premium Economy' },
  { value: 'business', label: 'Business' },
  { value: 'first', label: 'First' }
];

export default function CabinClassSelector({ value, onChange, className }) {
  const [isOpen, setIsOpen] = useState(false);

  const selectedClass = cabinClasses.find(c => c.value === value) || cabinClasses[0];
  
  const getDisplayLabel = (label) => {
    if (label === 'Premium Economy') return 'Premium';
    return label;
  };

  const handleSelect = (classValue) => {
    onChange(classValue);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            className={`w-full justify-start text-left text-base md:text-sm font-normal ${className} pl-9 max-[374px]:pl-8`}
          >
            <Plane className="absolute left-3 max-[374px]:left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-current opacity-80" />
            {getDisplayLabel(selectedClass.label)}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-52 rounded-2xl bg-brand-950/95 border-brand-800/45 text-white p-1.5 backdrop-blur-xl shadow-2xl" align="center" side="bottom" sideOffset={8}>
          <div className="space-y-0.5">
            {cabinClasses.map((cabinClass) => (
              <button
                key={cabinClass.value}
                type="button"
                onClick={() => handleSelect(cabinClass.value)}
                className={`w-full px-3.5 py-2.5 text-left transition-colors duration-200 flex items-center justify-between rounded-xl text-sm ${
                  value === cabinClass.value
                    ? 'bg-white/[0.07] text-white'
                    : 'text-white/85 hover:bg-white/[0.05] hover:text-white'
                }`}
              >
                <span>{cabinClass.label}</span>
                {value === cabinClass.value && (
                  <Check className="w-4 h-4 text-[hsl(228,75%,68%)]" />
                )}
              </button>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}